export enum DataSourceTypes {
  SURVEY = "survey",
  CHAT = "chat",
}

export enum GroupPathOptions {
  SURVEY = "structured_data",
  CHAT = "chat_fields",
}

export interface DataSource {
  uuid: string;
  label: string;
  source_type: DataSourceTypes;
  fully_imported: boolean;
  stale_es_migration: boolean;
  migrating: boolean;
  large: boolean;
}

export interface AvailableDimensions {
  segment: boolean;
  effort: boolean;
  fluff: boolean;
  topic: boolean;
  emotion: boolean;
  intent: boolean;
  emitter_role: boolean;
  emitter: boolean;
}
